module.exports = "<p>fourofour works!</p>\n"